var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 3.79167L9.0625 4.60417L7.39583 2.9375L8.20833 2.125C8.29167 2.04167 8.39583 2 8.52083 2C8.64583 2 8.75 2.04167 8.83333 2.125L9.875 3.16667C9.95833 3.25 10 3.35417 10 3.47917C10 3.60417 9.95833 3.70833 9.875 3.79167ZM2 8.33333L6.91667 3.41667L8.58333 5.08333L3.66667 10H2V8.33333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-edit.63f4dfbf8b0ddfdcf0b8485649ba12a0.svg";